<section class="campanhas-page plano-cadastro">
  @if (editando) {
    <!-- Edição: o mesmo cabeçalho das telas de parâmetros (nome, status e dados do plano). -->
    @if (plano(); as plano) {
      <app-plano-cabecalho [plano]="plano" (voltar)="voltarParaLista()" />
    }
  } @else {
    <header class="plano-cadastro__cabecalho">
      <app-trilha-navegacao [passos]="trilha" />

      <div class="plano-cadastro__linha">
        <div class="plano-cadastro__identificacao">
          <h1 class="plano-cadastro__titulo">Novo Plano</h1>
          <p class="plano-cadastro__subtitulo">Preencha os dados do plano para cadastrá-lo.</p>
        </div>

        <vivest-button variant="outline" size="md" data-testid="plano-cadastro-voltar" (click)="voltarParaLista()">
          <vivest-icon slot="icon-left" name="arrow-left" source="feather"></vivest-icon>
          Voltar para a lista
        </vivest-button>
      </div>
    </header>
  }

  <div class="plano-cadastro__conteudo">
    <!-- "Dados do Plano" sempre; "Instituto" e "Benefícios" só na edição; as outras ainda não existem e ficam
         desabilitadas. O design system não tem componente de abas: são botões com os tokens dele. -->
    <div class="plano-cadastro__abas" role="tablist" aria-label="Parametrização do plano" data-testid="plano-cadastro-abas">
      @for (aba of abas; track aba.id) {
        <button
          type="button"
          role="tab"
          class="plano-cadastro__aba"
          [class.plano-cadastro__aba--ativa]="abaAtiva() === aba.id"
          [id]="'plano-cadastro-aba-' + aba.id"
          [attr.aria-selected]="abaAtiva() === aba.id"
          [attr.aria-controls]="abaHabilitada(aba.id) ? 'plano-cadastro-painel-' + aba.id : null"
          [disabled]="!abaHabilitada(aba.id)"
          [attr.title]="abaHabilitada(aba.id) ? null : 'Disponível em breve'"
          [attr.data-testid]="'plano-cadastro-aba-' + aba.id"
          (click)="selecionarAba(aba.id)"
        >
          {{ aba.rotulo }}
        </button>
      }
    </div>

    <!-- Aba "Instituto": criada na primeira visita e mantida ao trocar de aba (não perde alterações). -->
    @if (idEdicao !== null && institutoAberto()) {
      <div
        id="plano-cadastro-painel-instituto"
        role="tabpanel"
        aria-labelledby="plano-cadastro-aba-instituto"
        [hidden]="abaAtiva() !== 'instituto'"
        data-testid="plano-cadastro-instituto"
      >
        <app-plano-institutos [planoId]="idEdicao" />
      </div>
    }

    <!-- Aba "Benefícios" (parametrizações dos benefícios do plano): mesma regra da aba "Instituto". -->
    @if (idEdicao !== null && beneficiosAberto()) {
      <div
        id="plano-cadastro-painel-beneficios"
        role="tabpanel"
        aria-labelledby="plano-cadastro-aba-beneficios"
        [hidden]="abaAtiva() !== 'beneficios'"
        data-testid="plano-cadastro-beneficios"
      >
        <app-beneficios [planoId]="idEdicao" [nomePlano]="plano()?.nome ?? ''" />
      </div>
    }

    <!-- Aba "Requerimento Online" (documentos e assinatura do requerimento): mesma regra da aba "Instituto". -->
    @if (idEdicao !== null && requerimentoAberto()) {
      <div
        id="plano-cadastro-painel-requerimento"
        role="tabpanel"
        aria-labelledby="plano-cadastro-aba-requerimento"
        [hidden]="abaAtiva() !== 'requerimento'"
        data-testid="plano-cadastro-requerimento"
      >
        <app-requerimento-online [planoId]="idEdicao" />
      </div>
    }

    <form
      id="plano-cadastro-painel-dados"
      role="tabpanel"
      aria-labelledby="plano-cadastro-aba-dados"
      [hidden]="abaAtiva() !== 'dados'"
      novalidate
      [formGroup]="form"
      (submit)="$event.preventDefault(); salvar()"
      data-testid="plano-cadastro-form"
    >
      <vivest-card variant="default" full-width data-testid="plano-cadastro-painel">
        <div class="plano-cadastro__painel">
          <div class="plano-cadastro__secao">
            <h2 class="plano-cadastro__secao-titulo">Dados do Plano</h2>
            <p class="plano-cadastro__secao-descricao">Os campos com * são obrigatórios.</p>
          </div>

          <div class="plano-cadastro__campos">
            @if (editando) {
              <!-- Na edição, código e produto não mudam. -->
              <vivest-input
                class="plano-cadastro__campo"
                autocomplete="off"
                icon=""
                label="Código do Plano"
                name="codigo"
                placeholder=""
                type="text"
                required
                disabled
                [value]="form.controls.codigo.value"
                data-testid="plano-cadastro-codigo"
              ></vivest-input>
              <vivest-input
                class="plano-cadastro__campo"
                autocomplete="off"
                icon=""
                label="Produto"
                name="produto"
                placeholder=""
                type="text"
                required
                disabled
                [value]="form.controls.produto.value?.descricao ?? ''"
                data-testid="plano-cadastro-produto"
              ></vivest-input>
            } @else {
              <!-- O código do plano é o do produto no Amadeus (/v1/planos, cod_plano): só vale quando escolhido
                   na lista, que traz apenas os planos ainda sem parametrização (uma por produto). -->
              <vivest-autocomplete
                class="plano-cadastro__campo"
                icon="search"
                label="Código do Plano"
                name="codigo"
                required
                [placeholder]="carregandoProdutos() ? 'Carregando planos…' : 'Busque pelo código ou nome'"
                [options]="opcoesProduto()"
                [disabled]="carregandoProdutos()"
                [attr.status]="erro('produto') ? 'error' : 'default'"
                [attr.error-message]="erro('produto')"
                (vivest-select)="selecionarProduto($event)"
                (input)="digitarProduto($event)"
                (focusout)="aoSairDoProduto()"
                data-testid="plano-cadastro-codigo"
              ></vivest-autocomplete>
            }

            <vivest-input
              class="plano-cadastro__campo"
              autocomplete="off"
              icon=""
              label="Nome do Plano"
              name="nome"
              placeholder="Digite o nome"
              type="text"
              required
              formControlName="nome"
              [attr.status]="erro('nome') ? 'error' : 'default'"
              [attr.error-message]="erro('nome')"
              data-testid="plano-cadastro-nome"
            ></vivest-input>

            <!-- A descrição só aparece na edição: o cadastro pede apenas código e nome. O tipo do plano não é mais informado. -->
            @if (editando) {
              <!-- O design system não tem textarea: campo nativo com o visual do vivest-input. -->
              <div class="plano-cadastro__campo plano-cadastro__campo--inteiro plano-cadastro__descricao">
                <label class="plano-cadastro__rotulo plano-cadastro__rotulo--obrigatorio" for="plano-cadastro-descricao">Descrição</label>
                <textarea
                  id="plano-cadastro-descricao"
                  class="plano-cadastro__textarea"
                  rows="4"
                  placeholder="Descreva o plano"
                  required
                  [attr.maxlength]="descricaoMaximo"
                  formControlName="descricao"
                  [attr.aria-invalid]="erro('descricao') ? true : null"
                  aria-describedby="plano-cadastro-descricao-contador plano-cadastro-descricao-erro"
                  data-testid="plano-cadastro-descricao"
                ></textarea>
                <p
                  id="plano-cadastro-descricao-contador"
                  class="plano-cadastro__contador"
                  data-testid="plano-cadastro-descricao-contador"
                >
                  {{ form.controls.descricao.value.length }}/{{ descricaoMaximo }}
                </p>
                @if (erro('descricao'); as mensagem) {
                  <p id="plano-cadastro-descricao-erro" class="plano-cadastro__erro" role="alert" data-testid="plano-cadastro-descricao-erro">
                    {{ mensagem }}
                  </p>
                }
              </div>
            }

            <!-- Todo plano novo nasce Ativo: o status só pode ser alterado na edição. -->
            @if (editando) {
              <fieldset class="plano-cadastro__campo plano-cadastro__campo--inteiro plano-cadastro__status" data-testid="plano-cadastro-status">
                <legend class="plano-cadastro__rotulo plano-cadastro__rotulo--obrigatorio">Status</legend>
                <div class="plano-cadastro__opcoes">
                  <vivest-radio label-variant="multi-line" name="status" value="Ativo" formControlName="status" data-testid="plano-cadastro-status-ativo">
                    Ativo
                  </vivest-radio>
                  <vivest-radio label-variant="multi-line" name="status" value="Inativo" formControlName="status" data-testid="plano-cadastro-status-inativo">
                    Inativo
                  </vivest-radio>
                </div>
              </fieldset>
            }
          </div>

          <footer class="plano-cadastro__rodape">
            <vivest-button variant="outline" size="md" data-testid="plano-cadastro-cancelar" (click)="voltarParaLista()">
              Cancelar
            </vivest-button>
            <vivest-button
              variant="primary"
              size="md"
              [disabled]="!podeSalvar()"
              data-testid="plano-cadastro-salvar"
              (click)="salvar()"
            >
              {{ salvando() ? 'Salvando…' : 'Salvar' }}
            </vivest-button>
          </footer>
        </div>
      </vivest-card>
    </form>
  </div>

  <!--
    Confirmação antes de salvar (vivest-modal do design system). Fica sempre no DOM e abre por
    [open]; Esc (dismissible) e o fechamento nativo do <dialog> disparam vivest-close.
  -->
  <vivest-modal
    [heading]="tituloConfirmacao"
    [description]="descricaoConfirmacao()"
    [open]="confirmandoSalvar()"
    [hasIcon]="false"
    dismissible=""
    (vivest-close)="cancelarSalvar()"
    data-testid="plano-cadastro-confirmar"
  >
    <vivest-button
      slot="actions"
      variant="outline"
      size="md"
      data-testid="plano-cadastro-confirmar-voltar"
      (click)="cancelarSalvar()"
    >
      Voltar
    </vivest-button>
    <vivest-button
      slot="actions"
      variant="primary"
      size="md"
      data-testid="plano-cadastro-confirmar-salvar"
      (click)="confirmarSalvar()"
    >
      Salvar
    </vivest-button>
  </vivest-modal>
</section>
